/**
 * @generated SignedSource<<23131c5eb5890a0bf4f02cee64e693b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type desktopRecorderApiRecorderStartLocalRecordingMutation$variables = {
  eventId?: string | null;
  noteId?: string | null;
};
export type desktopRecorderApiRecorderStartLocalRecordingMutation$data = {
  readonly createLocalRecording: {
    readonly meetingRecording: {
      readonly id: string;
      readonly note: {
        readonly id?: string;
        readonly url?: string | null;
      } | null;
    } | null;
  } | null;
};
export type desktopRecorderApiRecorderStartLocalRecordingMutation = {
  response: desktopRecorderApiRecorderStartLocalRecordingMutation$data;
  variables: desktopRecorderApiRecorderStartLocalRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  },
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiRecorderStartLocalRecordingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLocalRecording",
        "kind": "LinkedField",
        "name": "createLocalRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "type": "Note",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "desktopRecorderApiRecorderStartLocalRecordingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLocalRecording",
        "kind": "LinkedField",
        "name": "createLocalRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingRecording",
            "kind": "LinkedField",
            "name": "meetingRecording",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Note",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2bdb881c62c1fae559a24b59b0814682",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiRecorderStartLocalRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation desktopRecorderApiRecorderStartLocalRecordingMutation(\n  $eventId: ID\n  $noteId: ID\n) {\n  createLocalRecording(eventId: $eventId, noteId: $noteId) {\n    meetingRecording {\n      id\n      note {\n        __typename\n        ... on Note {\n          id\n          url\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "920d9972b261389ff92d3de593cd0674";

export default node;
